import { render, staticRenderFns } from "./DepjapaneseForm.vue?vue&type=template&id=704757a8&scoped=true&"
import script from "./DepjapaneseForm.vue?vue&type=script&lang=js&"
export * from "./DepjapaneseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704757a8",
  null
  
)

export default component.exports